import moment from 'moment'
let phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
// import ft from '../featureToggle'

export default {
  getList (VueApp, data, callback) {
    // let providers = VueApp.$store.state.provider.users
    let providers = VueApp.$store.state.services.users
    VueApp.$sdk.get('/provider', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: providers.currentPage,
      pageSize: providers.perPage,
      order: providers.order,
      orderAsc: providers.orderAsc,
      licenseType: providers.type,
      accountStatus: providers.status,
      search: providers.search,
      ...data
    }, res => {
      if (!res.error) {
        // VueApp.$store.commit('provider/setUserCurrentPage', providers.currentPage + 1)
        // VueApp.$store.commit('provider/setUserMaxList', res.paging.totalItems)
        VueApp.$store.commit('services/setUserMaxList', res.paging.totalItems)

        if (res.list.length) {
          for (let i = 0; i < res.list.length; i++) {
            let userInfo = res.list[i]
            let license = ''
            let insurance = ''
            let permit = ''
            let cityLicense = ''
            let airport = ''
            let safetyInspect = ''
            if (userInfo.vehicle) {
              if (userInfo.vehicle.driverLicenseExp && userInfo.vehicle.driverLicenseExp !== '0000-00-00 00:00:00') {
                license = moment(userInfo.vehicle.driverLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
              if (userInfo.vehicle.insurancePolicyExp && userInfo.vehicle.insurancePolicyExp !== '0000-00-00 00:00:00') {
                insurance = moment(userInfo.vehicle.insurancePolicyExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
              if (userInfo.vehicle.tcpPermitExp && userInfo.vehicle.tcpPermitExp !== '0000-00-00 00:00:00') {
                permit = moment(userInfo.vehicle.tcpPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
              if (userInfo.vehicle.cityLicenseExp && userInfo.vehicle.cityLicenseExp !== '0000-00-00 00:00:00') {
                cityLicense = moment(userInfo.vehicle.cityLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
              if (userInfo.vehicle.airportPermitExp && userInfo.vehicle.airportPermitExp !== '0000-00-00 00:00:00') {
                airport = moment(userInfo.vehicle.airportPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
              if (userInfo.providerAccountType === 'tnc') {
                permit = ''
                cityLicense = ''
                airport = ''
              }
              safetyInspect = userInfo.vehicle.vehicleSafetyInspectionByExp ? moment(userInfo.vehicle.vehicleSafetyInspectionByExp, 'YYYY-MM-DD').format('MM/DD/YYYY') : ''
            }
            let lastLogin = ''
            if (userInfo.lastLogin && userInfo.lastLogin !== 'Invalid date') {
              lastLogin = moment(userInfo.lastLogin, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm')
            }

            // VueApp.$store.commit('provider/addUser', {
            //   id: userInfo.ID,
            //   business: userInfo.businessName || '',
            //   type: userInfo.providerAccountType || '',
            //   status: userInfo.accountStatus,
            //   lastUpdate: userInfo.modified ? moment(userInfo.modified, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
            //   license: license,
            //   insurance: insurance,
            //   permit: permit,
            //   cityLicense: cityLicense,
            //   airport: airport,
            //   // drivingRecord: '****',
            //   safetyInspect: safetyInspect,
            //   // lastWeeksEarning: '****',
            //   // avgRating: '****',
            //   lastLogin: lastLogin,
            //   bgCheck: userInfo.backgroundCheck !== 'none',
            //   verified: userInfo.login && userInfo.login.verified === 1,
            //   archived: userInfo.login && userInfo.login.archived === 1,
            //   driverImg: userInfo.avatarUrl,
            //   carImg: userInfo.vehicle ? userInfo.vehicle.photoUrl : '',
            //   car: userInfo.vehicle ? userInfo.vehicle.manufacturer + ' ' + userInfo.vehicle.model : '',
            //   plateNo: userInfo.vehicle ? userInfo.vehicle.licensePlate : '',
            //   vehicleType: userInfo.vehicle ? userInfo.vehicle.type : ''
            // })

            VueApp.$store.commit('services/addUser', {
              id: userInfo.ID,
              business: userInfo.businessName || '',
              type: userInfo.providerAccountType || '',
              status: userInfo.accountStatus,
              lastUpdate: userInfo.modified ? moment(userInfo.modified, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
              license: license,
              insurance: insurance,
              permit: permit,
              cityLicense: cityLicense,
              airport: airport,
              // drivingRecord: '****',
              safetyInspect: safetyInspect,
              // lastWeeksEarning: '****',
              // avgRating: '****',
              lastLogin: lastLogin,
              bgCheck: userInfo.backgroundCheck !== 'none',
              verified: userInfo.login && userInfo.login.verified === 1,
              archived: userInfo.login && userInfo.login.archived === 1,
              driverImg: userInfo.avatarUrl,
              carImg: userInfo.vehicle ? userInfo.vehicle.photoUrl : '',
              car: userInfo.vehicle ? userInfo.vehicle.manufacturer + ' ' + userInfo.vehicle.model : '',
              plateNo: userInfo.vehicle ? userInfo.vehicle.licensePlate : '',
              vehicleType: userInfo.vehicle ? userInfo.vehicle.type : ''
            })
          }
        }
      }
      callback(res)
    })
  },
  getList2 (VueApp, data, callback) {
    // let self = this
    let providers = VueApp.$store.state.provider.users
    let params = {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: providers[data.target].currentPage,
      pageSize: providers[data.target].perPage,
      order: providers[data.target].order,
      orderAsc: providers[data.target].orderAsc,
      paging: 1,
      status: data.status,
      license: data.type,
      search: providers.search,
      // serviceTypeId: [providers.serviceType || '']
    }
    if (data.hasOwnProperty('isPax')) { params.isPax = data.isPax }
    if (data.hasOwnProperty('isDTD')) { params.isDTD = data.isDTD }
    VueApp.$sdk.get('/provider/export', params, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setUserMaxList', {
          target: data.target,
          value: res.paging.totalItems
        })

        if (res.list.length) {
          for (let i = 0; i < res.list.length; i++) {
            let userInfo = res.list[i]
            let lastLogin = '--'
            if (userInfo.lastDuty && userInfo.lastDuty !== 'Invalid date') {
              lastLogin = moment(userInfo.lastDuty, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm')
            }

            let service = ''
            if (userInfo.isPax) { service = 'PAX' }
            if (userInfo.isDTD) { service = 'DTD' }
            if (userInfo.isPax && userInfo.isDTD) { service = 'PAX/DTD' }
            VueApp.$store.commit('provider/addUser', {
              target: data.target,
              id: userInfo.ID,
              driverNum: userInfo.driverNum || '',
              business: userInfo.businessName || '',
              type: userInfo.licenseType || '',
              status: userInfo.duty || '',
              service: service,
              vehicleType: userInfo.vehicleType || '',
              city: userInfo.city,
              phone: userInfo.phoneNumber,
              created: userInfo.created ? moment(userInfo.created, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
              lastUpdate: userInfo.modified ? moment(userInfo.modified, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
              lastLogin: lastLogin,
              bgCheck: userInfo.backgroundCheck !== 'none',
              verified: userInfo.login && userInfo.login.verified === 1,
              bgCheckPassed: userInfo.backgroundCheckPassed,
              bgCheckSubmitted: userInfo.backgroundCheckSubmitted,
              wheelChairLift: userInfo.wheelChairLift
            })
          }
        }
        callback(res)
      } else {
        callback(res)
      }
    })
  },
  updateStatus (VueApp, data, callback) {
    let action = data.isActive ? 'post' : 'delete'

    VueApp.$sdk[action]('/provider/' + data.id + '/active', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  archiveUser (VueApp, id, callback) {
    VueApp.$sdk.post('/provider/' + id + '/archive', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  export (VueApp, target, callback) {
    let self = this
    let providers = VueApp.$store.state.provider.users
    let status = VueApp.$store.state.provider.users.status
    VueApp.$sdk.get('/provider/export', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: providers[target].currentPage,
      pageSize: providers[target].perPage,
      order: providers[target].order,
      orderAsc: providers[target].orderAsc,
      paging: 1,
      status: status,
      license: target,
      search: providers.search
    }, res => {
      if (!res.error) {
        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExportAll(value))
          })
        }
        callback(trx)
      } else {
        callback(res)
      }
    })
  },
  exportAll (VueApp, target, callback) {
    let self = this
    let providers = VueApp.$store.state.provider.users
    let params = {
      token: VueApp.$store.state.session.sessionToken,
      status: providers.status,
      license: target
    }
    if (providers.serviceFilter === 'PAX') {
      params.isPax = 1
      params.isDTD = 0
    }
    if (providers.serviceFilter === 'DTD') {
      params.isPax = 0
      params.isDTD = 1
    }
    if (providers.serviceFilter === 'PAX/DTD') {
      params.isPax = 1
      params.isDTD = 1
    }
    VueApp.$sdk.get('/provider/export', params, res => {
      if (!res.error) {
        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExportAll(value))
          })
        }
        callback(trx)
      } else {
        callback(res)
      }
    })
  },
  buildExport (data) {
    let license = ''
    let insurance = ''
    let permit = ''
    let cityLicense = ''
    let airport = ''
    let safetyInspect = ''
    if (data.vehicle) {
      license = moment(data.vehicle.driverLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
      insurance = moment(data.vehicle.insurancePolicyExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
      permit = moment(data.vehicle.tcpPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
      cityLicense = moment(data.vehicle.cityLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
      airport = moment(data.vehicle.airportPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
      if (data.providerAccountType === 'tnc') {
        permit = ''
        cityLicense = ''
        airport = ''
      }
      safetyInspect = data.vehicle.vehicleSafetyInspectionByExp ? moment(data.vehicle.vehicleSafetyInspectionByExp, 'YYYY-MM-DD').format('MM/DD/YYYY') : ''
    }
    let drivingRecordExp = ''
    if (data.drivingRecordExp) {
      drivingRecordExp = moment(data.drivingRecordExp, 'YYYY-MM-DD').format('MM/DD/YYYY')
    }
    let lastLogin = ''
    if (data.lastLogin) {
      lastLogin = moment(data.lastLogin, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm')
    }

    let bday = ''
    if (data.dateOfBirth) {
      bday = moment(data.dateOfBirth, 'YYYY-MM-DD').format('MM/DD/YYYY')
    }

    let mobile = ''
    let tempPhone = data.phone.toString()
    if (data.phone && typeof data.phone !== 'number') {
      mobile = data.phone
    } else if (data.phone && tempPhone.length > 9) {
      let number = phoneUtil.parseAndKeepRawInput('' + data.phone + '', 'US')
      mobile = phoneUtil.formatInOriginalFormat(number, 'US')
    }
    if (data.countryCode) {
      mobile = '+' + data.countryCode + ' ' + mobile
    }

    let shared = 0
    let opoli = 0
    let black = 0
    let suv = 0
    let shuttle = 0
    if (data.services && data.services.shared) { shared = 1 }
    if (data.services && data.services.opoli) { opoli = 1 }
    if (data.services && data.services.black) { black = 1 }
    if (data.services && data.services.suv) { suv = 1 }
    if (data.services && data.services.shuttle) { shuttle = 1 }

    let address1 = ''
    let address2 = ''
    let city = ''
    let state = ''
    let country = ''
    let zip = ''
    if (data.address) {
      address1 = data.address.addressLine1 || ''
      address2 = data.address.addressLine2 || ''
      city = data.address.city || ''
      state = data.address.state || ''
      country = data.address.country || ''
      zip = data.address.zipCode || ''
    }
    let created = ''
    if (data.created) {
      created = moment(data.created, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm:ss')
    }

    return {
      'Prov ID': data.ID,
      'Business Name': data.businessName || '',
      'Type': data.providerAccountType.toUpperCase() || '',
      'Status': data.accountStatus,
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Email': data.email,
      'Mobile': mobile,
      'Birthday': bday,
      'Address1': address1,
      'Address2': address2,
      'City': city,
      'State': state,
      'Country': country,
      'Zip': zip,
      'Language': data.language || 'english',
      'Created': created,
      'Last Update': moment(data.modified, 'YYYY-MM-DD').format('MM/DD/YYYY'),
      'Vehicle Type': data.vehicle.type || '',
      'Make': data.vehicle.manufacturer || '',
      'Model': data.vehicle.model || '',
      'Year': data.vehicle.manufactured || '',
      'License Plate': data.vehicle.licensePlate || '',
      'Seat Capacity': data.vehicle.seatCapacity,
      'VIN': data.vehicle.vehicleIdNumber,
      'Insurance Company Name': data.vehicle.insuranceCompany || '',
      'Insurance Policy #': data.vehicle.insurancePolicyNumber || '',
      'Insurance Exp. Date': insurance,
      'TCP Permit #': data.vehicle.tcpPermitNumber || '',
      'TCP Permit Exp. Date': permit,
      'City License #': data.vehicle.cityLicenseNumber || '',
      'City License Exp. Date': cityLicense,
      'Airport Permit #': data.vehicle.airportPermitNumber || '',
      'Airport Exp. Date': airport,
      'Driver\'s License #': data.vehicle.driverLicenseNumber || '',
      'Driver\'s License Exp. Date': license,
      'Driving Record Exp. Date': drivingRecordExp,
      'Safety Inspect': safetyInspect,
      'Last Login Timestamp': lastLogin,
      'BG Check': data.backgroundCheck !== 'none',
      'Shared': shared,
      'Opoli': opoli,
      'Black': black,
      'SUV': suv,
      'Private Shuttle': shuttle
    }
  },
  buildExportAll (data) {
    let licenseType = ''
    if (data.licenseType) {
      licenseType = data.licenseType.toUpperCase()
    }

    let bday = ''
    if (data.dateOfBirth) {
      let temp = moment(data.dateOfBirth, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        bday = temp.format('MM/DD/YYYY')
      }
    }

    let created = ''
    if (data.created) {
      let temp = moment(data.created, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        created = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let modified = ''
    if (data.modified) {
      let temp = moment(data.modified, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        modified = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let insurance = ''
    if (data.insurancePolicyExp) {
      let temp = moment(data.insurancePolicyExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        insurance = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let permit = ''
    if (data.tcpPermitExp) {
      let temp = moment(data.tcpPermitExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        permit = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let cityLicense = ''
    if (data.cityLicenseExp) {
      let temp = moment(data.cityLicenseExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        cityLicense = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let airport = ''
    if (data.airportPermitExp) {
      let temp = moment(data.airportPermitExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        airport = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let license = ''
    if (data.driverLicenseExp) {
      let temp = moment(data.driverLicenseExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        license = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let drivingRecordExp = ''
    if (data.drivingRecordExp) {
      let temp = moment(data.drivingRecordExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        drivingRecordExp = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let safetyInspect = ''
    if (data.vehicleSafetyInspectionByExp) {
      let temp = moment(data.vehicleSafetyInspectionByExp, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        safetyInspect = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let lastLogin = ''
    if (data.lastLogin) {
      let temp = moment(data.lastLogin, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        lastLogin = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let service = ''
    if (data.isPax) { service = 'PAX' }
    if (data.isDTD) { service = 'DTD' }
    if (data.isPax && data.isDTD) { service = 'PAX/DTD' }

    
    return {
      'Prov ID': data.ID,
      'Business Name': data.businessName || '',
      'Type': licenseType,
      'Status': data.status,
      'Service': service,
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Email': data.email,
      'Mobile': data.phoneNumber,
      'Birthday': bday,
      'SSN': data.businessSSN || '',
      'EIN': data.businessEIN || '',
      'Address1': data.addressLine1 || '',
      'Address2': data.addressLine2 || '',
      'City': data.city,
      'State': data.state,
      'Country': data.country,
      'Zip': data.zipCode,
      'Language': data.language || 'english',
      'Created Date': created,
      'Last Update': modified,
      'Vehicle Type': data.vehicleType || '',
      'Make': data.make || '',
      'Model': data.model || '',
      'Year': data.makeYear || '',
      'License Plate': data.licensePlate || '',
      'Seat Capacity': data.seatCapacity,
      'VIN': data.vehicleIdNumber || '',
      'Insurance Company Name': data.insuranceCompany || '',
      'Insurance Policy #': data.insurancePolicyNumber || '',
      'Insurance Exp. Date': insurance,
      'TCP Permit #': data.tcpPermitNumber || '',
      'TCP Permit Exp. Date': permit,
      'City License #': data.cityLicenseNumber || '',
      'City License Exp. Date': cityLicense,
      'Airport Permit #': data.airportPermitNumber || '',
      'Airport Exp. Date': airport,
      'Driver\'s License #': data.driverLicenseNumber || '',
      'Driver\'s License Exp. Date': license,
      'Driving Record Exp. Date': drivingRecordExp,
      'Safety Inspect': safetyInspect,
      'Last Login Timestamp': lastLogin,
      'BG Check': data.backgroundCheckPassed !== 0,
      'Services': data.serviceTypeNames || ''
      // 'Shared': shared,
      // 'Opoli': opoli,
      // 'Black': black,
      // 'SUV': suv,
      // 'Private Shuttle': shuttle
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/list.js